document.addEventListener("DOMContentLoaded", function () {
    // Get the button element to open the modal
    var openModalBtnLink = document.getElementById("openModalBtnLink");
    var closeModalBtn = document.getElementById("closeModalBtn");
    var modal = document.getElementById("myModal");
    var openCalendlyBtn = document.getElementById("openCalendlyBtn");
    var callButton = document.querySelector(".call-button");
    var phoneNumber = document.querySelector(".phone-number");
    
    // Function to open the modal
    function openModal() {
        modal.style.display = "block";
    }

    // Function to close the modal
    function closeModal() {
        modal.style.display = "none";
    }

    // Event listener for the button to open the modal
    if (openModalBtnLink) {
      openModalBtnLink.addEventListener("click", openModal);
    }
    
    // Event listener for the close button to close the modal
    if (closeModalBtn) {
      closeModalBtn.addEventListener("click", closeModal);
    }

    // Event listener to close the modal when clicking anywhere outside the modal content
    window.addEventListener("click", function (event) {
        if (event.target === modal) {
            closeModal();
        }
    });

    // Function to open the Calendly widget
    function openCalendlyWidget() {
        // Call Calendly's initPopupWidget function
        Calendly.initPopupWidget({
            url: 'https://calendly.com/contact-scs/30min?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=1a1a1a'
        });
    }

    // Event listener for the "CALL" button
    if (callButton) { 
      callButton.addEventListener("click", function () {
        if (callButton.textContent === "CALL") {
          callButton.textContent = phoneNumber.textContent;
        } else {
          callButton.textContent = "CALL";
        }
      });

      // Initially hide the phone number
      callButton.querySelector(".phone-number").style.display = "none";
    }
    
    if (openCalendlyBtn) {
      // Event listener to open the Calendly widget when clicking "BOOK AN APPOINTMENT"
      openCalendlyBtn.addEventListener("click", function (e) {
        e.preventDefault(); // Prevent the default link behavior
        closeModal(); // Close the modal
        openCalendlyWidget(); // Open the Calendly widget
      });
    }
});

// CUSTOM CODE - opens external links in new tab
var links = document.links; 
for(let i = 0, linksLength = links.length; i < linksLength; i++){
  if (links[i].hostname !== window.location.hostname) { 
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  } 
}

document.addEventListener("DOMContentLoaded", function () {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.productId = this.dataset.productId;
      // 1-based index of the listable option (0 = none) and its kind
      // ("size" → "SIZE " prefix in the badge, "letter" → bare values),
      // rendered by card-product.liquid.
      this.sizeOptionIndex = parseInt(this.dataset.sizeOptionIndex || "0", 10);
      this.sizeOptionKind = this.dataset.sizeOptionKind || "";

      // Check if this is a grouped product (sibling-based)
      const siblingMapEl = this.querySelector('[data-sibling-card-map]');
      if (siblingMapEl) {
        try {
          this.siblingData = JSON.parse(siblingMapEl.textContent);
        } catch(e) {
          console.error('ProductCard: failed to parse sibling map JSON for product', this.productId, e);
        }
      }

      this.isGroupedProduct = !!this.siblingData;

      if (!this.isGroupedProduct) {
        // Legacy product: load variant data
        const productVariantsJson = this.querySelector(
          "[data-product-variants-json]"
        );
        if (productVariantsJson) {
          this.variants = JSON.parse(productVariantsJson.textContent);
        }

        if (!this.variants) {
          const variantElement = document.getElementById(
            `VariantsJSON-${this.productId}`
          );

          if (variantElement) {
            this.variants = JSON.parse(variantElement.textContent);
          }
        }
      }

      const shipVariantsJson = this.querySelector(
        "[data-product-variants-ship-json]"
      );

      if (shipVariantsJson) {
        this.variantShippingStatus = JSON.parse(
          shipVariantsJson.textContent
        );
        this.isReadyToShip = Object.values(this.variantShippingStatus).some(
          (value) => value === "true"
        );
      }

      this.state = {
        selectedMaterial: null,
        selectedStone: null,
        selectedVariant: null,
        price: null,
        image: null,
      };
    }

    connectedCallback() {
      this.init();
    }

    init() {
      if (this.isGroupedProduct) {
        this.initGroupedProduct();
      } else {
        this.initVariant();
      }
      this.renderMaterialStoneOptions();
      this.setSelectedClasses();
      if (!this.isGroupedProduct) {
        this.updateVariant();
      }
    }

    initGroupedProduct() {
      const metalInput = this.querySelector('[data-card-current-metal]');
      const diamondInput = this.querySelector('[data-card-current-diamond]');
      this.state.selectedMaterial = metalInput ? metalInput.value : null;
      this.state.selectedStone = diamondInput ? diamondInput.value : null;

      // Re-format initial price to match JS currency format for consistency
      if (this.siblingData) {
        const currentSibling = this.siblingData.find(s =>
          s.metal === this.state.selectedMaterial && s.diamond === this.state.selectedStone
        );
        if (currentSibling) {
          this.updatePrice(currentSibling.price, currentSibling.request_only === true);
        }
      }
    }

    initVariant() {
      if (this.variants && this.variants.length > 0) {
        const readyToShipVariants = this.variants.filter(
          (variant) =>
            this.variantShippingStatus &&
            this.variantShippingStatus[variant.id] === "true"
        );

        // Prioritize lab-grown stone type among ready-to-ship variants
        let selectedVariant = null;

        if (readyToShipVariants.length > 0) {
          // Try to find a lab-grown ready-to-ship variant first
          const labGrownRTS = readyToShipVariants.find((v) => {
            const opts = [v.option1, v.option2, v.option3].filter(Boolean);
            return opts.some((o) => o.toLowerCase().includes("lab"));
          });

          if (labGrownRTS) {
            selectedVariant = labGrownRTS;
          } else {
            // No lab-grown ready-to-ship; fall back to first ready-to-ship (natural)
            selectedVariant = readyToShipVariants[0];
          }
        } else {
          // No ready-to-ship variants; default to first lab-grown, then first variant
          const labGrownVariant = this.variants.find((v) => {
            const opts = [v.option1, v.option2, v.option3].filter(Boolean);
            return opts.some((o) => o.toLowerCase().includes("lab"));
          });
          selectedVariant = labGrownVariant || this.variants[0];
        }
        
        this.state.selectedVariant = selectedVariant.id;

        const options = [
          selectedVariant.option1,
          selectedVariant.option2,
          selectedVariant.option3,
        ];

        this.state.selectedMaterial =
          options.find((opt) =>
            this.querySelector(`.material-button[data-material="${opt}"]`)
          ) || null;

        this.state.selectedStone = options.find(
          (opt) => opt !== this.state.selectedMaterial
        );

        this.setSelectedClasses();
      }
    }

    renderMaterialStoneOptions() {
      const materialButtons = this.querySelectorAll(".material-button");
      const stoneButtons = this.querySelectorAll(".stone-button");

      materialButtons.forEach((button) => {
        button.addEventListener("click", (event) => {
          this.state.selectedMaterial = event.target.dataset.material;
          if (this.isGroupedProduct) {
            this.updateGroupedCard();
          } else {
            this.updateVariant();
          }
          this.setSelectedClasses();
        });
      });

      stoneButtons.forEach((button) => {
        button.addEventListener("click", (event) => {
          this.state.selectedStone = event.target.dataset.stone;
          if (this.isGroupedProduct) {
            this.updateGroupedCard();
          } else {
            this.updateVariant();
          }
          this.setSelectedClasses();
        });
      });
    }

    updateGroupedCard() {
      if (!this.siblingData) return;

      const metal = this.state.selectedMaterial;
      const diamond = this.state.selectedStone;

      // Find matching sibling
      const match = this.siblingData.find(s => s.metal === metal && s.diamond === diamond);
      if (!match) return;

      // Update card link
      const productLinks = this.querySelectorAll("a.full-unstyled-link");
      productLinks.forEach(link => {
        link.href = match.url;
      });

      // Update price (hide entirely for REQUEST_ONLY siblings)
      this.updatePrice(match.price, match.request_only === true);

      // Update image
      if (match.image) {
        const imgEl = this.querySelector(".card__media img");
        if (imgEl) {
          imgEl.src = match.image;
          imgEl.srcset = "";
          imgEl.alt = "Product Image";
          imgEl.removeAttribute("data-src");
          imgEl.classList.remove("lazyloaded", "lazyload");
        }
      }

      // Update secondary (hover) image
      const secondaryImgEl = this.querySelector(".card__media .media--hover-effect img:nth-child(2)");
      if (secondaryImgEl) {
        if (match.secondaryImage) {
          secondaryImgEl.src = match.secondaryImage;
          secondaryImgEl.srcset = "";
          secondaryImgEl.removeAttribute("data-src");
          secondaryImgEl.classList.remove("lazyloaded", "lazyload");
          secondaryImgEl.style.display = "";
        } else {
          secondaryImgEl.style.display = "none";
        }
      }

      // Update card title
      if (match.title) {
        const titleEl = this.querySelector(".card__heading-model");
        if (titleEl) {
          titleEl.textContent = match.title;
        }
      }

      // Update availability / ready-to-ship label. Badge copy is always
      // English (client requirement); CSS uppercases it.
      const readyToShipLabel = this.querySelector("#ready-to-ship-label");
      if (readyToShipLabel) {
        if (!match.available) {
          readyToShipLabel.textContent = "Sold Out";
          readyToShipLabel.style.display = "block";
        } else if (match.readyToShip) {
          // match.sizes is the display string from product-rts-info.liquid
          // ("SIZE 50, 52" or bare letters "A, B, K") — prefix already baked in.
          readyToShipLabel.textContent = match.sizes
            ? `Ready to Ship (${match.sizes})`
            : "Ready to Ship";
          readyToShipLabel.style.display = "block";
        } else {
          readyToShipLabel.style.display = "none";
        }
      }
    }

    setSelectedClasses() {
      const materialButtons = this.querySelectorAll(".material-button");
      const stoneButtons = this.querySelectorAll(".stone-button");

      materialButtons.forEach((btn) => {
        if (btn.dataset.material === this.state.selectedMaterial) {
          btn.classList.add("selected");
        } else {
          btn.classList.remove("selected");
        }
      });

      stoneButtons.forEach((btn) => {
        if (btn.dataset.stone === this.state.selectedStone) {
          btn.classList.add("selected");
        } else {
          btn.classList.remove("selected");
        }
      });
    }

    updateVariant() {
      // Cards may render only stone swatches, only metal swatches, or both —
      // match on whichever are selected.
      if (!this.state.selectedMaterial && !this.state.selectedStone) return;

      const selectedVariant = this.variants.find((variant) => {
        const options = [variant.option1, variant.option2, variant.option3];

        const matchMaterial = this.state.selectedMaterial
          ? options.includes(this.state.selectedMaterial)
          : true;
        const matchStone = this.state.selectedStone
          ? options.includes(this.state.selectedStone)
          : true;

        return matchMaterial && matchStone;
      });

      if (selectedVariant) {
        this.updateState(selectedVariant);
        this.updateProductLink(selectedVariant.id);
        this.updateImage(selectedVariant.featured_image);
        this.updatePrice(selectedVariant.price);
      }
      this.updateReadyToShipLabel();
    }

    updateState(variant) {
      this.state.selectedVariant = variant.id;
      this.state.price = variant.price;
      this.state.image = variant.featured_image;
    }

    updateProductLink(variantId) {
      const productLinks = this.querySelectorAll("a.full-unstyled-link");

      productLinks.forEach((productLink) => {
        const url = new URL(window.location.origin + productLink.pathname);
        url.searchParams.set("variant", variantId);
        productLink.href = url.toString();
      });
    }

    updatePrice(price, requestOnly = false) {
      // REQUEST_ONLY siblings have no public price — hide the whole price wrapper
      // so swapping into a request-only sibling does not flash a stale or $0 value.
      const priceWrapper = this.querySelector(".price__regular");
      if (priceWrapper) {
        priceWrapper.style.display = requestOnly ? "none" : "";
      }
      if (requestOnly) return;

      const priceElement = this.querySelector(".price-item--regular");

      if (priceElement) {
        const activeCurrency = Shopify.currency?.active || "EUR";
        const formattedPrice = (price / 100).toLocaleString(undefined, {
          style: "currency",
          currency: activeCurrency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });

        priceElement.textContent = formattedPrice;
      }
    }

    updateImage(image) {
      if (!image || !image.src) return;

      const imgEl = this.querySelector(".card__media img");
      if (imgEl) {
        imgEl.src = `https:${image.src}`;
        imgEl.srcset = "";
        imgEl.alt = image.alt || "Product Image";
        imgEl.removeAttribute("data-src");
        imgEl.classList.remove("lazyloaded", "lazyload");
      }
    }

    updateReadyToShipLabel() {
      // Badge reflects the current swatch selection: shown only when at least
      // one variant matching the selected stone/metal is ready to ship, with
      // the in-stock sizes or letters of that selection. Badge copy is always
      // English (client requirement); CSS uppercases it.
      const readyToShipLabel = this.querySelector("#ready-to-ship-label");
      if (!readyToShipLabel) return;

      const readyVariants = this.variants.filter((v) => {
        if (this.variantShippingStatus?.[v.id] !== "true") return false;
        const options = [v.option1, v.option2, v.option3];
        if (
          this.state.selectedMaterial &&
          !options.includes(this.state.selectedMaterial)
        ) {
          return false;
        }
        if (
          this.state.selectedStone &&
          !options.includes(this.state.selectedStone)
        ) {
          return false;
        }
        return true;
      });

      if (readyVariants.length > 0) {
        let label = "Ready to Ship";
        if (this.sizeOptionIndex > 0) {
          const sizes = [
            ...new Set(
              readyVariants
                .map((v) =>
                  [v.option1, v.option2, v.option3][this.sizeOptionIndex - 1]
                )
                .filter(Boolean)
                .map((s) => s.replace(".", ""))
            ),
          ]
            .sort()
            .join(", ");
          if (sizes) {
            const prefix = this.sizeOptionKind === "size" ? "SIZE " : "";
            label = `Ready to Ship (${prefix}${sizes})`;
          }
        }

        readyToShipLabel.textContent = label;
        readyToShipLabel.style.display = "block";
      } else {
        readyToShipLabel.style.display = "none";
      }
    }
  }

  if (!customElements.get("product-card")) {
    customElements.define("product-card", ProductCard);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const swatches = document.querySelectorAll(".product-swatch");
  const url = window.location.pathname;
  swatches.forEach(function (swatch) {
    const swatchUrl = new URL(swatch.getAttribute("href"), window.location.origin).pathname;

    if (swatchUrl === url) {
      swatch.classList.add("active");
    } else {
      swatch.classList.remove("active");
    }
  });
});